/*
 *
 * !!! DO NOT MODIFY DIRECTLY !!!
 *
 * @generated via scripts/import-icons
 *
 */

import React from 'react'

import { CssVars } from '../../../themes'
import { TextColorOverride } from '../../TextColorOverride'

export function Info12({
  color,
}: {
  color?: React.ComponentProps<typeof TextColorOverride>['color']
}) {
  const node = (
    <svg
      fill="none"
      height="12"
      role="img"
      viewBox="0 0 12 12"
      width="12"
      xmlns="http://www.w3.org/2000/svg"
    >
      <path
        d="M6.625 3.375V4.5h-1.25V3.375h1.25Zm-1.25 5.25v-3h1.25v3h-1.25Z"
        fill={CssVars.textColor}
      />
      <path
        clipRule="evenodd"
        d="M6 11.25c2.887 0 5.25-2.363 5.25-5.25C11.25 3.112 8.887.75 6 .75 3.112.75.75 3.112.75 6c0 2.887 2.362 5.25 5.25 5.25ZM10 6c0 2.197-1.803 4-4 4S2 8.197 2 6s1.803-4 4-4 4 1.803 4 4Z"
        fill={CssVars.textColor}
        fillRule="evenodd"
      />
    </svg>
  )
  return color ? (
    <TextColorOverride color={color}>
      {({ rootClassName }) => (
        // NOTE(jare): Since the svg node's display is "inline", it can be
        // rendered with a little whitespace around it in certain cases. We
        // wrap it in a flexbox container to remove that whitespace.
        <span className={rootClassName} css={{ display: 'inline-flex' }}>
          {node}
        </span>
      )}
    </TextColorOverride>
  ) : (
    node
  )
}
